import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsTaxiForwardingContract from "./contracts-taxi-forwarding-contract";
import ContractsTaxiForwardingContractParams from "./contracts-taxi-forwarding-contract-params";

const useContractsTaxiForwardingContract = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsTaxiForwardingContract>(
      { data: [], totalCount: 0 },
      false,
    );

  const load = async (
    params: ContractsTaxiForwardingContractParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const contractsTaxiForwarding: ContractsTaxiForwardingContract =
        await contractsService.getTaxiForwardingContract(params, signal);

      setData(contractsTaxiForwarding);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useContractsTaxiForwardingContract;
